/**
 * The max number of results a typeahead request will return
 */
export const TYPEAHEAD_MAX_RETURN = 100;

/**
 * The breakpoint for Project Sirius, in px
 */
export const SIRIUS_BREAKPOINT = 600;
